export default __webpack_public_path__ + "1b4e001.png";